"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const flavourCarouselInputs = [
  {
    name: "backgroundImage",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
  },
  {
    name: "description",
    type: "string",
    defaultValue:
      "A Minty Fruity flavour, with Mango taste and complex tropical fruit tonalities. The volatile mango flavor gives way to a fresh, cool mouth sensation.",
  },
  {
    name: "title",
    type: "string",
    defaultValue: "Tabacco",
  },
  {
    name: "redirectLink",
    type: "object",
    subFields: [
      {
        name: "label",
        type: "string",
      },
      {
        name: "url",
        type: "string",
      },
      {
        name: "openIn",
        friendlyName: "Open in",
        type: "string",
        enum: ["new Tab", "same Tab"],
        onChange: `options.set("target", (options.get("openIn") === "new Tab"? "_blank" : "_self"))`,
      },
      {
        hideFromUI: true,
        name: "target",
        type: "string",
        enum: ["_blank", "_self"],
      },
    ],
    defaultValue: {
      label: "Shop the range",
      url: "/",
      target: "_self",
    },
  },
  {
    name: "isThumbnailsCarouselHidden",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isInversed",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const FlavourCarouselComponent: RegisteredComponent = {
  name: "FlavourCarousel",
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  component: dynamic(async () =>
    withValidation(flavourCarouselInputs, (await import("./FlavourCarousel")).FlavourCarousel, "FlavourCarousel")
  ),
  inputs: flavourCarouselInputs,
};
